import styled from 'styled-components';
import { Flex } from '../../../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'ContentPromotionBudgetWeek' })
    .attrs({
        width: '100%',
    })``;
